import { useTranslation } from 'react-i18next';

/**
 * WCAG 2.4.1 — first focusable control on heavy-chrome layouts; jumps to #main-content.
 */
export function SkipToMainLink() {
  const { t } = useTranslation('common');

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[300] focus:rounded-lg focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-foreground focus:shadow-modal focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
    >
      {t('a11y.skipToMain')}
    </a>
  );
}
